import type {
    MiniappEthTransactionRequest,
    MiniappSignatureMethod,
    MiniappSignatureParams,
} from 'hooks/useMiniappEthereumProvider'

type ValidationArgs = {
    method: MiniappSignatureMethod
    params: MiniappSignatureParams
    fromAddress: string
}

type MethodValidator = (args: ValidationArgs, expected: string) => boolean

const personalSignValidator: MethodValidator = (args, expected) => {
    return (
        Array.isArray(args.params) &&
        args.params.length === 2 &&
        (args.params[1] as string).toLowerCase() === expected.toLowerCase()
    )
}

const ethSignValidator: MethodValidator = (args, expected) => {
    return (
        Array.isArray(args.params) &&
        args.params.length === 2 &&
        (args.params[0] as string).toLowerCase() === expected.toLowerCase()
    )
}

const typedDataValidator: MethodValidator = (args, expected) => {
    return (
        Array.isArray(args.params) &&
        args.params.length === 2 &&
        (args.params[0] as string).toLowerCase() === expected.toLowerCase()
    )
}

const validators: Record<MiniappSignatureMethod, MethodValidator> = {
    personal_sign: personalSignValidator,
    eth_sign: ethSignValidator,
    eth_signTypedData: typedDataValidator,
    eth_signTypedData_v4: typedDataValidator,
}

export const validateMiniappSignatureRequest = (
    args: ValidationArgs,
    smartAccountAddress: string,
) => {
    const normalizedExpected = smartAccountAddress?.toLowerCase()
    if (!normalizedExpected) {
        throw new Error('Smart account address is unavailable')
    }

    const validator = validators[args.method]
    if (!validator) {
        throw new Error(`Unsupported signature method: ${args.method}`)
    }

    const isValid = validator(args, normalizedExpected)
    if (!isValid) {
        throw new Error('Miniapp must request signatures from the smart account only')
    }
}

export const validateMiniappTransactionRequest = (
    tx: MiniappEthTransactionRequest,
    smartAccountAddress: string,
) => {
    if (!tx) {
        throw new Error('Miniapp transaction payload is missing')
    }

    const normalizedFrom = tx.from?.toLowerCase()
    if (normalizedFrom !== smartAccountAddress.toLowerCase()) {
        throw new Error('Miniapp must send transactions from the smart account only')
    }
}
